import { useState } from "react";
import {useSelector } from "react-redux";
import {} from "react-router-dom";
import { toast } from "react-toastify";
import { LeaveStateEnum } from "../modal/leave-state"; 
import { LeaveTypeEnum } from "../modal/leave-type";
import moment from "moment";
import ReportCard from "../components/ReportCard";
import {useEffect} from "react";
import {useDispatch} from "react-redux";
import * as authAction from "../Store/_redux/AuthStore/authActions";

function MonthlyReportPage() {
  const dispatch = useDispatch();
  useEffect(() => { dispatch(authAction.getUsers()); }, [dispatch]);
  const [showReport, setShowReport] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filterMonth, setFilterMonth] = useState("");
  const [mainarg, setMainarg] = useState([]);
  const formLeave = useSelector((state) => state.leave.leaves) || [];
  const formUsers = useSelector((state) => state.auth.users) || [];  
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Ay seçilmeli
    if (!filterMonth) {
      toast.error("Lütfen bir ay seçin");
      return;
    }
    // İşleme başla.
    setLoading(true);
    try {
        

        //Seçilen ayın başlangıcı ve bitişi.
        const startOfMonth = moment(filterMonth).startOf("month");
        const endOfMonth = moment(filterMonth).endOf("month");
        let defaultWorkingDays = 0;
        //Bir ayda kaç iş günü var onu hesapla. (Hafta sonları hariç)
        for (let d = moment(startOfMonth.clone()); d.isSameOrBefore(endOfMonth.clone()); d.add(1, "day")) {
            if (d.day() !== 0 && d.day() !== 6) {
                defaultWorkingDays++;
            }
        }
        let arg = [];
        formUsers.forEach((user) => {
                  let sick = 0;
                  let annual = 0;
                  let birth = 0;
                  let paid = 0;   
                  let fullday = 0;
                  let izinGun = [];
        //Kullanıcı ve izin kimlik numarasına göre izinleri filtrele ve hesapla.
        const selectedUserObj = formUsers.find((u) => String(u._id) === String(user._id));
            formLeave.forEach((leave) => {
                if (leave.state === LeaveStateEnum.APPROVED && leave.owner.tc === selectedUserObj.tc) {
                const leaveStart = moment(leave.startDate);
                const leaveEnd = moment(leave.finishDate);
                for (let d = startOfMonth.clone(); d.isSameOrBefore(endOfMonth); d.add(1, "day")) {
                    //Haftasonunu sayma ve izin tarihleri arasında olup olmadığını kontrol et.
                    const isWeekDay = d.day() !== 0 && d.day() !== 6;
                    
                    if (isWeekDay && (d.isBetween(leaveStart, leaveEnd, "day", "[]"))) {
                      //Yarım gün mü değil mi onu kontrol et.
                       let isHalfDay = false;
                        if (leave.isStartHalf && d.isSame(leaveStart, "day")) {
                            isHalfDay = true;
                        }
                        else if (leave.isEndHalf && d.isSame(leaveEnd, "day")) {
                            isHalfDay = true;
                        }
                        else if (leave.isHalfDay && (d.isSame(leaveStart, "day") || d.isSame(leaveEnd, "day"))) {
                            isHalfDay = true;
                        }
                        // Yarım günse 1 yerine 0.5 ekle, tam günse 1 ekle.
                        if (isHalfDay) {
                            izinGun.push({ date: d.format("YYYY-MM-DD"), isHalfDay: true });
                            fullday += 0.5;
                            if (leave.leavesType === LeaveTypeEnum.SICK) sick += 0.5;
                            else if (leave.leavesType === LeaveTypeEnum.ANNUAL) annual += 0.5;
                            else if (leave.leavesType === LeaveTypeEnum.MATERNITY) birth += 0.5;
                            else if (leave.leavesType === LeaveTypeEnum.UNPAID) paid += 0.5;
                        } 
                        else {
                            izinGun.push({ date: d.format("YYYY-MM-DD"), isHalfDay: false });
                            fullday++;
                            if (leave.leavesType === LeaveTypeEnum.SICK) sick++;
                            else if (leave.leavesType === LeaveTypeEnum.ANNUAL) annual++;
                            else if (leave.leavesType === LeaveTypeEnum.MATERNITY) birth++;
                            else if (leave.leavesType === LeaveTypeEnum.UNPAID) paid++; 
                        }     
                    }
                }
            }
          });
          arg.push({user: selectedUserObj, Sick: sick, Annual: annual, Birth: birth, Paid: paid, IzinGun: izinGun, finalWorkingDays: defaultWorkingDays - fullday, finalLeaveDays: fullday, finalWorkingHours: (defaultWorkingDays - fullday) * 8});
        });
        setShowReport(true);
        setMainarg(arg);
    } catch (error) {
      toast.error("Bir hata oluştu");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-6xl mx-auto p-6 space-y-6">
      <h1 className="text-2xl font-semibold mb-6">Aylık Rapor</h1>
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Dönem (Ay)</label>
          <input
            type="month"
            value={filterMonth}
            onChange={(e) => { setFilterMonth(e.target.value); setShowReport(false); }}
            className="border rounded px-3 py-2 min-w-[200px]"
            title="Ay seç"
          /> 
        </div>

        <div className="flex gap-2">
          <button
            type="submit"
            disabled={loading}
            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 disabled:bg-blue-300 transition-colors font-medium text-sm"
          >
            {loading ? "Yükleniyor..." : "Raporu Görüntüle"}
          </button>
        </div>
      </form>

      {showReport && (
        <div className="w-full bg-white rounded-lg shadow p-6 border border-gray-100">
          <ReportCard
            mainarray={mainarg}
            selectedMonth={filterMonth}
          />
        </div>
      )}
    </div>
  );
}
export default MonthlyReportPage;